// entry point for React side of plugin
